export const auth = {
    LOGIN: 'auth/login',
    LOADING: 'auth/loading',
    ERROR: 'auth/error',
    LOGGED_IN: 'auth/LOGGED_IN',
    LOGGED_OUT: 'auth/LOGGED_OUT',
    FORGOT_PASSWORD_REQUEST: 'auth/forgot_password_request',   // For the request state
    FORGOT_PASSWORD_SUCCESS: 'auth/forgot_password_success',   // For successful email sending
    FORGOT_PASSWORD_FAILURE: 'auth/forgot_password_failure',   // For failure/error state
}
export const user = {
    GET: 'user/get',
    USER: 'user/save',
    PUSH: 'user/push',
    LOADING: 'user/loading',
    ERROR: 'user/error',
}
export const post = {
    GET: 'post/get',
    POST: 'post/save',
    PUT: 'post/put',
    DELETE: 'post/delete',
    PUSH: 'post/push',
    LOADING: 'post/loading',
    ERROR: 'post/error',
}
export const address = {
    GET: 'address/get',
    ADDRESS: 'address/save',
    PUSH: 'address/push',
    PUT: 'address/put',
    DELETE: 'address/delete',
    LOADING: 'address/loading',
    ERROR: 'address/error',
}
export const role = {
    GET: 'role/get',
    ROLE: 'role/save',
    PUSH: 'role/push',
    PUT: 'role/put',
    DELETE: 'role/delete',
    LOADING: 'role/loading',
    ERROR: 'role/error',
}
export const request = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete',
}
export const menu = {
    CHANGE: 'change',
}
